/**
 * Map between individual stringing-guide beads and the recipe lines in the
 * stringing list, including runs nested inside a Repeat block.
 */

function runKeyFor(groupIndex, slotIndex = null) {
  return slotIndex == null
    ? `g${groupIndex}`
    : `g${groupIndex}-s${slotIndex}`;
}

/**
 * @returns {{
 *   runKeys: string[],
 *   runKeyForBead: (beadIndex: number) => string | null,
 *   beadIndexesForRun: (runKey: string) => number[],
 * }}
 */
export function buildStringingCrossHighlight(groups) {
  const list = Array.isArray(groups) ? groups : [];
  const beadToRun = [];
  const runToBeads = new Map();
  const runKeys = [];

  const addRange = (runKey, start, count) => {
    if (!runToBeads.has(runKey)) {
      runToBeads.set(runKey, []);
      runKeys.push(runKey);
    }
    const beads = runToBeads.get(runKey);
    for (let i = 0; i < count; i++) {
      const beadIndex = start + i;
      beadToRun[beadIndex] = runKey;
      beads.push(beadIndex);
    }
  };

  let beadCursor = 0;

  list.forEach((group, groupIndex) => {
    if (!group || group.type === "divide") return;

    if (group.type === "repeat") {
      const pattern = Array.isArray(group.pattern) ? group.pattern : [];
      const repeatCount = Math.max(0, Math.floor(Number(group.repeatCount)) || 0);
      const slotCounts = pattern.map((run) =>
        Math.max(0, Math.floor(Number(run?.count)) || 0)
      );
      const patternBeads = slotCounts.reduce((sum, n) => sum + n, 0);

      pattern.forEach((_, slotIndex) => {
        const runKey = runKeyFor(groupIndex, slotIndex);
        const before = slotCounts
          .slice(0, slotIndex)
          .reduce((sum, n) => sum + n, 0);
        const count = slotCounts[slotIndex];
        for (let rep = 0; rep < repeatCount; rep++) {
          addRange(runKey, beadCursor + rep * patternBeads + before, count);
        }
      });

      beadCursor += patternBeads * repeatCount;
      return;
    }

    if (group.type === "single" && group.item) {
      const count = Math.max(0, Math.floor(Number(group.item.count)) || 0);
      const runKey = runKeyFor(groupIndex);
      addRange(runKey, beadCursor, count);
      beadCursor += count;
    }
  });

  return {
    runKeys,
    runKeyForBead: (beadIndex) => {
      const index = Math.floor(Number(beadIndex));
      if (!Number.isInteger(index) || index < 0) return null;
      return beadToRun[index] ?? null;
    },
    beadIndexesForRun: (runKey) => {
      if (runKey == null) return [];
      return runToBeads.get(runKey)?.slice() ?? [];
    },
  };
}
